import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-add-market-standard-dialog',
  templateUrl: './add-market-standard-dialog.component.html',
  styleUrls: ['./add-market-standard-dialog.component.scss']
})
export class AddMarketStandardDialogComponent {
  @Input() public standardTitle: string = '';

  constructor(public activeModal: NgbActiveModal) { }

  confirm() {
    this.activeModal.close(true);
  }

  cancel() {
    this.activeModal.dismiss(false);
  }
}
